// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VerifySessionPopover — UI Conventions: fade-in 120~200ms ease-out, reduced-motion 가드 */

.VerifySessionPopover_popover__FZTHm {
    position: fixed;
    z-index: 1100;
    background: var(--color-bg-tertiary, #fff);
    border: 1px solid var(--color-border, #d1d5db);
    border-radius: 6px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
    font-size: 12px;
    color: var(--color-text, #1f2937);
    animation: VerifySessionPopover_vsp-fade-in__ggZRE 160ms ease-out;
    overflow: hidden;
}

@keyframes VerifySessionPopover_vsp-fade-in__ggZRE {
    from { opacity: 0; transform: translateY(-3px); }
    to   { opacity: 1; transform: translateY(0); }
}

.VerifySessionPopover_titleBar__Gq3WP {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 10px;
    background: var(--color-bg-secondary, #f3f4f6);
    border-bottom: 1px solid var(--color-border, #e5e7eb);
}

.VerifySessionPopover_title__wEVum {
    font-weight: 600;
    font-size: 12px;
    color: var(--color-text, #1f2937);
}

.VerifySessionPopover_closeBtn__ybPUP {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    color: var(--color-text-muted, #6b7280);
    padding: 2px;
    border-radius: 3px;
    transition: background-color 150ms ease, color 150ms ease;
}
.VerifySessionPopover_closeBtn__ybPUP:hover {
    background: var(--color-hover, #e5e7eb);
    color: var(--color-text, #1f2937);
}

.VerifySessionPopover_body__2yQv4 {
    padding: 10px 12px;
    max-height: 320px;
    overflow-y: auto;
}

.VerifySessionPopover_center__CwyNR {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 0;
    color: var(--color-text-muted, #6b7280);
}

.VerifySessionPopover_spinner__EYxL- {
    width: 14px;
    height: 14px;
    border: 2px solid var(--color-border, #d1d5db);
    border-top-color: #3b82f6;
    border-radius: 50%;
    animation: VerifySessionPopover_vsp-spin__enLyE 800ms linear infinite;
}
@keyframes VerifySessionPopover_vsp-spin__enLyE {
    to { transform: rotate(360deg); }
}

.VerifySessionPopover_headerOk__\\+nx22 {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    color: #10b981;
    font-weight: 600;
}

.VerifySessionPopover_detail__ELvJY .VerifySessionPopover_row__1HiY1,
.VerifySessionPopover_row__1HiY1 {
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding: 3px 0;
    border-bottom: 1px dashed var(--color-border, #f3f4f6);
}
.VerifySessionPopover_detail__ELvJY .VerifySessionPopover_row__1HiY1:last-child,
.VerifySessionPopover_row__1HiY1:last-child {
    border-bottom: none;
}

.VerifySessionPopover_label__ZTq2C {
    flex: 0 0 110px;
    color: var(--color-text-muted, #6b7280);
    font-size: 11px;
    text-transform: lowercase;
}

.VerifySessionPopover_value__j8RCL {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--color-text, #1f2937);
    font-variant-numeric: tabular-nums;
}

.VerifySessionPopover_dim__WH5HG { color: var(--color-text-muted, #9ca3af); }

.VerifySessionPopover_errorBox__HGkCw,
.VerifySessionPopover_infoBox__e8UcO {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 6px 0;
}

.VerifySessionPopover_errorBox__HGkCw > svg { color: #ef4444; flex-shrink: 0; margin-top: 2px; }
.VerifySessionPopover_infoBox__e8UcO  > svg { color: #3b82f6; flex-shrink: 0; margin-top: 2px; }

.VerifySessionPopover_errorTitle__LUsKK,
.VerifySessionPopover_infoTitle__Oahav {
    font-weight: 600;
    margin-bottom: 2px;
}

.VerifySessionPopover_errorTitle__LUsKK { color: #ef4444; }
.VerifySessionPopover_infoTitle__Oahav  { color: var(--color-text, #1f2937); }

.VerifySessionPopover_errorMsg__8Glv7,
.VerifySessionPopover_infoMsg__uXlSm {
    color: var(--color-text-muted, #6b7280);
    font-size: 11px;
    line-height: 1.5;
    word-break: keep-all;
}

/* 다크 모드 */
[data-theme="dark"] .VerifySessionPopover_popover__FZTHm {
    background: var(--color-bg-tertiary);
    border-color: var(--color-border);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.5);
}
[data-theme="dark"] .VerifySessionPopover_titleBar__Gq3WP {
    background: var(--color-bg-secondary);
    border-bottom-color: var(--color-border);
}

/* prefers-reduced-motion 가드 */
@media (prefers-reduced-motion: reduce) {
    .VerifySessionPopover_popover__FZTHm { animation: none; }
    .VerifySessionPopover_spinner__EYxL- { animation-duration: 2400ms; }
    .VerifySessionPopover_closeBtn__ybPUP { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/VerifySessionPopover.module.css"],"names":[],"mappings":"AAAA,yFAAyF;;AAEzF;IACI,eAAe;IACf,aAAa;IACb,0CAA0C;IAC1C,8CAA8C;IAC9C,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;IACf,iCAAiC;IACjC,iEAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,8CAA8C;IAC9C,qDAAqD;AACzD;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,uCAAuC;IACvC,YAAY;IACZ,kBAAkB;IAClB,yDAAyD;AAC7D;AACA;IACI,uCAAuC;IACvC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8CAA8C;IAC9C,yBAAyB;IACzB,kBAAkB;IAClB,qEAAyC;AAC7C;AACA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,cAAc;IACd,sDAAsD;AAC1D;AACA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,uCAAuC;IACvC,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iCAAiC;IACjC,kCAAkC;AACtC;;AAEA,mCAAO,uCAAuC,EAAE;;AAEhD;;IAEI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,cAAc;AAClB;;AAEA,8CAAkB,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE;AACnE,8CAAkB,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEnE;;IAEI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,0CAAc,cAAc,EAAE;AAC9B,0CAAc,iCAAiC,EAAE;;AAEjD;;IAEI,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,UAAU;AACV;IACI,oCAAoC;IACpC,iCAAiC;IACjC,yCAAyC;AAC7C;AACA;IACI,qCAAqC;IACrC,wCAAwC;AAC5C;;AAEA,8BAA8B;AAC9B;IACI,uCAAW,eAAe,EAAE;IAC5B,uCAAW,0BAA0B,EAAE;IACvC,wCAAY,gBAAgB,EAAE;AAClC","sourcesContent":["/* VerifySessionPopover — UI Conventions: fade-in 120~200ms ease-out, reduced-motion 가드 */\n\n.popover {\n    position: fixed;\n    z-index: 1100;\n    background: var(--color-bg-tertiary, #fff);\n    border: 1px solid var(--color-border, #d1d5db);\n    border-radius: 6px;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);\n    font-size: 12px;\n    color: var(--color-text, #1f2937);\n    animation: vsp-fade-in 160ms ease-out;\n    overflow: hidden;\n}\n\n@keyframes vsp-fade-in {\n    from { opacity: 0; transform: translateY(-3px); }\n    to   { opacity: 1; transform: translateY(0); }\n}\n\n.titleBar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 10px;\n    background: var(--color-bg-secondary, #f3f4f6);\n    border-bottom: 1px solid var(--color-border, #e5e7eb);\n}\n\n.title {\n    font-weight: 600;\n    font-size: 12px;\n    color: var(--color-text, #1f2937);\n}\n\n.closeBtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    color: var(--color-text-muted, #6b7280);\n    padding: 2px;\n    border-radius: 3px;\n    transition: background-color 150ms ease, color 150ms ease;\n}\n.closeBtn:hover {\n    background: var(--color-hover, #e5e7eb);\n    color: var(--color-text, #1f2937);\n}\n\n.body {\n    padding: 10px 12px;\n    max-height: 320px;\n    overflow-y: auto;\n}\n\n.center {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 10px 0;\n    color: var(--color-text-muted, #6b7280);\n}\n\n.spinner {\n    width: 14px;\n    height: 14px;\n    border: 2px solid var(--color-border, #d1d5db);\n    border-top-color: #3b82f6;\n    border-radius: 50%;\n    animation: vsp-spin 800ms linear infinite;\n}\n@keyframes vsp-spin {\n    to { transform: rotate(360deg); }\n}\n\n.headerOk {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 8px;\n    color: #10b981;\n    font-weight: 600;\n}\n\n.detail .row,\n.row {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    padding: 3px 0;\n    border-bottom: 1px dashed var(--color-border, #f3f4f6);\n}\n.detail .row:last-child,\n.row:last-child {\n    border-bottom: none;\n}\n\n.label {\n    flex: 0 0 110px;\n    color: var(--color-text-muted, #6b7280);\n    font-size: 11px;\n    text-transform: lowercase;\n}\n\n.value {\n    flex: 1 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: var(--color-text, #1f2937);\n    font-variant-numeric: tabular-nums;\n}\n\n.dim { color: var(--color-text-muted, #9ca3af); }\n\n.errorBox,\n.infoBox {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 6px 0;\n}\n\n.errorBox > svg { color: #ef4444; flex-shrink: 0; margin-top: 2px; }\n.infoBox  > svg { color: #3b82f6; flex-shrink: 0; margin-top: 2px; }\n\n.errorTitle,\n.infoTitle {\n    font-weight: 600;\n    margin-bottom: 2px;\n}\n\n.errorTitle { color: #ef4444; }\n.infoTitle  { color: var(--color-text, #1f2937); }\n\n.errorMsg,\n.infoMsg {\n    color: var(--color-text-muted, #6b7280);\n    font-size: 11px;\n    line-height: 1.5;\n    word-break: keep-all;\n}\n\n/* 다크 모드 */\n[data-theme=\"dark\"] .popover {\n    background: var(--color-bg-tertiary);\n    border-color: var(--color-border);\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.5);\n}\n[data-theme=\"dark\"] .titleBar {\n    background: var(--color-bg-secondary);\n    border-bottom-color: var(--color-border);\n}\n\n/* prefers-reduced-motion 가드 */\n@media (prefers-reduced-motion: reduce) {\n    .popover { animation: none; }\n    .spinner { animation-duration: 2400ms; }\n    .closeBtn { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `VerifySessionPopover_popover__FZTHm`,
	"vsp-fade-in": `VerifySessionPopover_vsp-fade-in__ggZRE`,
	"titleBar": `VerifySessionPopover_titleBar__Gq3WP`,
	"title": `VerifySessionPopover_title__wEVum`,
	"closeBtn": `VerifySessionPopover_closeBtn__ybPUP`,
	"body": `VerifySessionPopover_body__2yQv4`,
	"center": `VerifySessionPopover_center__CwyNR`,
	"spinner": `VerifySessionPopover_spinner__EYxL-`,
	"vsp-spin": `VerifySessionPopover_vsp-spin__enLyE`,
	"headerOk": `VerifySessionPopover_headerOk__+nx22`,
	"detail": `VerifySessionPopover_detail__ELvJY`,
	"row": `VerifySessionPopover_row__1HiY1`,
	"label": `VerifySessionPopover_label__ZTq2C`,
	"value": `VerifySessionPopover_value__j8RCL`,
	"dim": `VerifySessionPopover_dim__WH5HG`,
	"errorBox": `VerifySessionPopover_errorBox__HGkCw`,
	"infoBox": `VerifySessionPopover_infoBox__e8UcO`,
	"errorTitle": `VerifySessionPopover_errorTitle__LUsKK`,
	"infoTitle": `VerifySessionPopover_infoTitle__Oahav`,
	"errorMsg": `VerifySessionPopover_errorMsg__8Glv7`,
	"infoMsg": `VerifySessionPopover_infoMsg__uXlSm`
};
export default ___CSS_LOADER_EXPORT___;
